import {
  TermsAndConditionsApi,
  CreateTermsAndConditionsDTO,
  UpdateTermsAndConditionsDTO
} from '../api-client/generated';

const apiCaller = new TermsAndConditionsApi();

const getPaginatedTermsAndConditions = async (params: any) => {
  const response = await apiCaller.termsAndConditionsGetAllPaginated(params);
  const { data } = response;
  return data;
};

const getAllTermsAndConditions = async () => {
  const response = await apiCaller.termsAndConditionsGetAll();
  const { data } = response;
  return data;
};

const getTermsAndConditionsById = async (id: string) => {
  const response = await apiCaller.termsAndConditionsGetOneById({ id });
  const { data } = response;
  return data;
};

const createTermsAndConditions = async (
  termsAndConditions: CreateTermsAndConditionsDTO
) => {
  const response = await apiCaller.termsAndConditionsCreate({
    createTermsAndConditionsDTO: termsAndConditions
  });
  const { data } = response;
  return data;
};

const updateTermsAndConditions = async (
  id: string,
  termsAndConditions: UpdateTermsAndConditionsDTO
) => {
  const response = await apiCaller.termsAndConditionsUpdate({
    id,
    updateTermsAndConditionsDTO: termsAndConditions
  });
  const { data } = response;
  return data;
};

const deleteTermsAndConditions = async (id: string) => {
  const response = await apiCaller.termsAndConditionsDelete({ id });
  const { data } = response;
  return data;
};

export default {
  createTermsAndConditions,
  deleteTermsAndConditions,
  getAllTermsAndConditions,
  getPaginatedTermsAndConditions,
  getTermsAndConditionsById,
  updateTermsAndConditions
};
